import getLockingSystemCharges, {
	MinimalComponentWithCharges,
} from "@secureo/common/utils/lockingSystems/getLockingSystemCharges"

import { LockingSystemComponent } from "@secureo/common/typings/LockingSystem"
import { LockingSystemReducerState } from ".."

const getMinimalComponentWithChargesFromComponent = (
	lockingSystemComponent: LockingSystemComponent,
) => {
	const {
		uuid,
		attributes: { lockingSystemChargesByMatrixType },
		quantity,
		pricePortions: { productSingleNetPriceCents },
	} = lockingSystemComponent

	const minimalComponentWithCharges: MinimalComponentWithCharges = {
		uuid,
		quantity,
		lockingSystemChargesByMatrixType,
		productSingleNetPriceCents,
	}

	return minimalComponentWithCharges
}

const getReducerStateWithLockingSystemCharges = (reducerState: LockingSystemReducerState) => {
	const { matrix, lockingComponentsUuids, keyComponentsUuids, componentsByUuid, taxRate } =
		reducerState

	const lockingComponents = lockingComponentsUuids.map((uuid) => {
		const component = componentsByUuid[uuid]

		return getMinimalComponentWithChargesFromComponent(component)
	})

	const keyComponents = keyComponentsUuids.map((uuid) => {
		const component = componentsByUuid[uuid]

		return getMinimalComponentWithChargesFromComponent(component)
	})

	const charges = getLockingSystemCharges(matrix, lockingComponents, keyComponents, taxRate)

	const updatedReducerState: LockingSystemReducerState = {
		...reducerState,
		charges,
	}

	return updatedReducerState
}

export default getReducerStateWithLockingSystemCharges
